import { Injectable } from '@angular/core';
// import {Cookie} from 'ng2-cookies/ng2-cookies';
import { HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
@Injectable()
export class ConfigService {

  constructor(private Cookie: CookieService) { }
  header = new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.getItem('devtoken') || '', 'lan': 'en' });
  // header = new HttpHeaders({ 'Content-Type': 'application/json','authorization': sessionStorage.getItem('devtoken') || '', 'lan': 'en' });

  // Start of New functions
  // set operator id
  setOperatorId(values) {
    this.Cookie.set('operatorid', values);
  }
  // get operator id
  getOperatorId(va) {
    return this.Cookie.get(va);
  }
  // set city id
  setCityId(values) {
    this.Cookie.set('cityid', values);
  }
  // get city id
  getCityId(va) {
    return this.Cookie.get(va);
  }
  // End of New functions

  // Login response
  setItem(values) {
    this.Cookie.set('roleType', values.roleType, 5, '/');
    this.Cookie.set('devtoken', values.token, 5, '/');
    this.Cookie.set('email', values.email, 5, '/');
    this.Cookie.set('firstName', values.firstName, 5, '/');
    this.Cookie.set('devid', values.fingerprint, 5, '/');
    this.Cookie.set('sid', values.sid, 5, '/');
    this.Cookie.set('profilePic', values.Location, 5, '/');
    this.Cookie.set('phone', values.phone, 5, '/');
    this.Cookie.set('dispatchermqtt', values.dispatcherMqttChannel, 5, '/');
    this.Cookie.set('dispatcherId', values.id, 5, '/');
    this.header = new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': values.token || '', 'lan': 'en' });
  }
  getItem(va) {
    return this.Cookie.get(va);
  }
  setAuth() {
    this.header = new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.getItem('devtoken') || '', 'lan': 'en' });
    return this.header;
  }

  // config
  setConfig(values) {
    this.Cookie.set('customerApiInterval', values.customerApiInterval, 5, '/');
    this.Cookie.set('stripe', values.stripePublishKey, 5, '/');
    this.Cookie.set('someone', values.isBookingForSomeoneElseEnable, 5, '/');
  }

  // config
  setSetting(values) {
    this.Cookie.set('accountType', values.accountType, 5, '/');
    this.Cookie.set('sid', values.sid, 5, '/');
    this.Cookie.set('devtoken', values.token, 5, '/');
  }

  getConfig(va) {
    return this.Cookie.get(va);
  }

  getSettings(value) {
    return this.Cookie.get(value);
  }

  getHeaders() {
  }

  // remove item
  removeItem() {
    this.Cookie.delete('devtoken');
  }

  // fare estimate
  setFareEstimate(values) {
    this.Cookie.set('timeFee', values.timeFee, 5, '/');
    this.Cookie.set('distance', values.distance, 5, '/');
    this.Cookie.set('distanceFee', values.distanceFee, 5, '/');
    this.Cookie.set('duration', values.duration, 5, '/');
  }
  getFareEstimate(va) {
    return this.Cookie.get(va);
  }

  // Book Now
  setBookNow(values) {
    this.Cookie.set('bookingId', values.bookingId, 5, '/');
  }
  getBookNow(va) {
    return this.Cookie.get(va);
  }

  // Book Now
  setForgotPass(values) {
    this.Cookie.set('sid', values.sid, 5, '/');
  }
  getForgotPass(va) {
    return this.Cookie.get(va);
  }


  // wallet details
  setWalletDetails(values) {
    this.Cookie.set('walletBalance', values.walletBalance, 5, '/');
    this.Cookie.set('isEnabled', values.isEnabled, 5, '/');
    this.Cookie.set('currencySymbol', values.currencySymbol, 5, '/');
    this.Cookie.set('walletSoftLimit', values.walletSoftLimit, 5, '/');
    this.Cookie.set('walletHardLimit', values.walletHardLimit, 5, '/');
  }
  getWalletDetails(va) {
    return this.Cookie.get(va);
  }

  clearAllCookies() {
    console.log('this.Cookie.getAll()', this.Cookie.getAll());
    this.Cookie.deleteAll();
  }


  // Profile Details
  setProfile(values) {
    this.Cookie.set('firstName', values.firstName, 5, '/');
    this.Cookie.set('lastName', values.lastName, 5, '/');
    this.Cookie.set('email', values.email, 5, '/');
    this.Cookie.set('phone', values.phone, 5, '/');
    this.Cookie.set('profilePic', values.profilePic, 5, '/');
  }
  getProfile(va) {
    return this.Cookie.get(va);
  }


  setNewCookie(name, value, days?) {
    this.Cookie.set(name, value, days ? days : 1);
  }

}
